export function shouldMarkInteractionFromMoveStart(
  hasOriginalEvent: boolean,
  isWithinProgrammaticMoveWindow: boolean,
): boolean {
  return hasOriginalEvent && !isWithinProgrammaticMoveWindow
}

export function shouldMarkInteractionFromNativeEvent(
  isWithinProgrammaticMoveWindow: boolean,
): boolean {
  return !isWithinProgrammaticMoveWindow
}

export function shouldRestoreReusedMapCamera(
  hasLoadedMapInstance: boolean,
  hasDestinationFallback: boolean,
  hasBoundsFallback: boolean,
  hasMarkers: boolean,
): boolean {
  return hasLoadedMapInstance && (hasDestinationFallback || hasBoundsFallback || hasMarkers)
}

export function shouldTriggerBoundsSearch(
  ignoreNextIdle: boolean,
  hasInteracted: boolean,
): boolean {
  return !ignoreNextIdle && hasInteracted
}

export function shouldReapplySearchCameraAfterResultsChange(
  hasMap: boolean,
  isSearchBlocked: boolean,
  hasSearchSettledEnoughToRefit: boolean,
  hasManualSearchContext: boolean,
  hasUserInteractedSinceManualSearch: boolean,
): boolean {
  return hasMap &&
    !isSearchBlocked &&
    hasSearchSettledEnoughToRefit &&
    hasManualSearchContext &&
    !hasUserInteractedSinceManualSearch
}
